(function() {
  'use strict';

  window.zESettings = {
    webWidget: {
      contactForm: {
        ticketForms: [{ id: 360001978952 }]
      }
    }
  };

  window.zE = window.zE || function() {
    (zE.q = zE.q || []).push(arguments);
  };

  function configureDynamicSettings() {
    zE(function() {
      const getLocaleFromShopifyRoutes = () => {
        const defaultLocale = 'en-ca';

        if (window.Shopify && Shopify.routes && typeof Shopify.routes.root === 'string') {
          const rootPath = Shopify.routes.root;
          const locale = rootPath.replace(/^\/|\/$/g, '');

          if (locale) {
            return locale;
          }
        }
        return defaultLocale;
      };

      const zendeskLocale = getLocaleFromShopifyRoutes();
      zE('webWidget', 'setLocale', zendeskLocale);
    });
  }

  function initializeContactTriggers() {
    const contactTriggers = document.querySelectorAll(
      '.contact-trigger'
    );
    contactTriggers.forEach(function(trigger) {
      trigger.addEventListener('click', function(e) {
        e.preventDefault();
        if (typeof zE === 'function') {
          zE('webWidget', 'updateSettings', {
            webWidget: { helpCenter: { suppress: true } }
          });
          zE('webWidget', 'toggle');
        }
      });
    });
  }


  function initZendeskFeatures() {
    configureDynamicSettings();
    initializeContactTriggers();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initZendeskFeatures);
  } else {
    initZendeskFeatures();
  }
})();